import { FilterModel } from './../models/filter.model';

export type FilterState = FilterModel[];

export const initialState: FilterState = [] as FilterState;
